/* eslint-disable */
import { observable, action, computed } from 'mobx'

import autoStore from './autoStore'

class Config {
  constructor() {
    this.theme = 0

    autoStore('cofnig', this)
  }

  @observable theme = 0

  @action
  setTheme = index => {
    this.theme = index
  }
}

export default new Config()



// WEBPACK FOOTER //
// ./src/stores/Config.js